/**
 * Audio DAW Library - Main Entry Point
 * A canvas-based audio waveform editor library
 * Provides only the canvas UI - buttons/controls are the responsibility of the host application
 */

// Import all modules
import { Track } from './audio/Track.js';
import { Timeline } from './timeline/Timeline.js';
import { DEFAULT_THEME, DARK_THEME } from './rendering/theme.js';
import { ViewportRenderer } from './rendering/ViewportRenderer.js';
import { WaveformGenerator, LocalWaveform } from './waveform/WaveformGenerator.js';
import { RemoteWaveform } from './waveform/RemoteWaveform.js';
import { RemoteSpectrogram } from './spectrogram/RemoteSpectrogram.js';
import { buildColormapLut, COLORMAP_NAMES } from './spectrogram/colormaps.js';
import { WaveformSource } from './waveform/WaveformSource.js';
import { PeakLevel, chooseLevels } from './waveform/PeakData.js';
import { AudioDAW } from './core/AudioDAW.js';

// Export all modules for direct access if needed
export {
  Track,
  Timeline,
  DEFAULT_THEME,
  DARK_THEME,
  ViewportRenderer,
  WaveformGenerator,
  WaveformSource,
  LocalWaveform,
  RemoteWaveform,
  RemoteSpectrogram,
  COLORMAP_NAMES,
  buildColormapLut,
  PeakLevel,
  chooseLevels,
  AudioDAW
};

// Default export is AudioDAW for backward compatibility
export default AudioDAW;

// CommonJS compatibility for Node.js environments
if (typeof module !== 'undefined' && module.exports) {
  module.exports = AudioDAW;
  module.exports.AudioDAW = AudioDAW;
  module.exports.Track = Track;
  module.exports.Timeline = Timeline;
  module.exports.DEFAULT_THEME = DEFAULT_THEME;
  module.exports.DARK_THEME = DARK_THEME;
  module.exports.ViewportRenderer = ViewportRenderer;
  module.exports.WaveformGenerator = WaveformGenerator;
  module.exports.WaveformSource = WaveformSource;
  module.exports.LocalWaveform = LocalWaveform;
  module.exports.RemoteWaveform = RemoteWaveform;
  module.exports.RemoteSpectrogram = RemoteSpectrogram;
  module.exports.COLORMAP_NAMES = COLORMAP_NAMES;
  module.exports.buildColormapLut = buildColormapLut;
  module.exports.PeakLevel = PeakLevel;
  module.exports.chooseLevels = chooseLevels;
}

// Browser global for non-module usage
if (typeof window !== 'undefined') {
  window.AudioDAW = AudioDAW;
}
